import React from "react";
import { Box, Text, Stack } from "@mantine/core";
import { IconCheck } from "@tabler/icons-react";

interface PaymentSuccessMessageProps {
  message?: string;
}

export default function PaymentSuccessMessage({
  message = "Checkout Complete",
}: PaymentSuccessMessageProps) {
  return (
    <Box
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: "16px",
        padding: "32px 16px",
        animation: "fadeIn 0.5s ease-in",
      }}
    >
      <Box
        style={{
          width: "64px",
          height: "64px",
          borderRadius: "50%",
          backgroundColor: "var(--brand-lime-green)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          boxShadow: "0 4px 12px rgba(162, 213, 94, 0.3)",
        }}
      >
        <IconCheck size={32} color="white" />
      </Box>

      <Text
        size="xl"
        fw={600}
        style={{
          color: "var(--brand-lime-green)",
          textAlign: "center",
        }}
      >
        {message}
      </Text>

      <Text size="sm" c="dimmed" ta="center">
        Returning to transaction view...
      </Text>
    </Box>
  );
}
